/**
 * @typedef {object} NavState
 * @property {object} competition
 * @property {number|null} competition.id
 * @property {object} season
 * @property {number|null} season.id
 * @property {string|null} season.providerId
 * @property {number} round
 */
